// src/constants/lpConfig.js

/**
 * LP専用設定（StampRallyPage 用）
 *
 * 旧 campaigns.js + 旧 goalConfig.js の LP 部分を統合。
 *
 * 【運用ルール】
 * - ラリー追加時: LP_CONFIG に新エントリを追加してデプロイ
 * - `all` ラリーはLPページが存在しないため記載しない
 * - lpGoalCount: LP画面での達成閾値（mapGoalCount とは独立）
 *
 * 【報酬（everyoneGoal.reward）の設定方法】
 * ① 報酬未確定: reward: null
 * ② テキストのみ: reward: { text: '〇〇限定Tシャツ' }
 * ③ テキスト+画像: reward: { text: '〇〇', imageUrl: '/images/rewards/xxx.jpg' }
 */
export const LP_CONFIG = {
  ueno: {
    id: 'ueno',
    name: '上野動物園周辺スポットラリー',
    siteUrl: 'https://diary.rural.ne.jp',
    everyoneGoal: {
      description: '6ヶ所全てで250スタンプ以上達成',
      reward: null,
    },
    userGoal: {
      description: '上野ラリーの全スポットをコンプリートすると〇〇がもらえます',
      reward: null,
    },
    spots: {
      ueno_1: { lpGoalCount: 250 },
      ueno_2: { lpGoalCount: 250 },
      ueno_3: { lpGoalCount: 250 },
      ueno_4: { lpGoalCount: 250 },
      ueno_5: { lpGoalCount: 250 },
      ueno_6: { lpGoalCount: 250 },
    },
  },

  katsurahama: {
    id: 'katsurahama',
    name: '桂浜水族館周辺スポットラリー',
    siteUrl: 'https://diary.rural.ne.jp',
    everyoneGoal: {
      description: '7ヶ所全てで250スタンプ以上達成',
      reward: null,
    },
    userGoal: {
      description: '桂浜ラリーの全スポットをコンプリートすると〇〇がもらえます',
      reward: null,
    },
    spots: {
      katsurahama_7:  { lpGoalCount: 250 },
      katsurahama_8:  { lpGoalCount: 250 },
      katsurahama_9:  { lpGoalCount: 250 },
      katsurahama_10: { lpGoalCount: 250 },
      katsurahama_11: { lpGoalCount: 250 },
      katsurahama_12: { lpGoalCount: 250 },
      katsurahama_13: { lpGoalCount: 250 },
    },
  },

  kasairinkai: {
    id: 'kasairinkai',
    name: '葛西臨海水族園',
    siteUrl: 'https://diary.rural.ne.jp',
    everyoneGoal: {
      description: '6ヶ所全てで250スタンプ以上達成',
      reward: null,
    },
    userGoal: {
      description: '葛西ラリーの全スポットをコンプリートすると〇〇がもらえます',
      reward: null,
    },
    spots: {
      kasairinkai_14: { lpGoalCount: 100 },
      kasairinkai_15: { lpGoalCount: 100 },
      kasairinkai_16: { lpGoalCount: 100 },
      kasairinkai_17: { lpGoalCount: 100 },
      kasairinkai_18: { lpGoalCount: 100 },
      kasairinkai_19: { lpGoalCount: 100 },
      kasairinkai_20: { lpGoalCount: 100 },
    },
  },
};

/** デフォルトキャンペーンID（StampRallyPage のデフォルトリダイレクト先） */
export const DEFAULT_CAMPAIGN_ID = 'ueno';

/** LP画面でのスタンプ達成しきい値（全ラリー共通） */
export const STAMP_GOAL = 100;

/**
 * LP用スタンプ達成閾値を取得するヘルパー
 *
 * @param {string} spotId  - スポットID（例: "ueno_1"）
 * @param {string} rallyId - ラリーID（例: "ueno"）
 * @returns {number}
 */
export const getLpGoalCount = (spotId, rallyId) => {
  return LP_CONFIG[rallyId]?.spots[spotId]?.lpGoalCount ?? 0;
};
